export default {
    data() {
        return {
            sortByDirections: [
                {name: 'Ascending', item: 1},
                {name: 'Descending', item: -1}
            ],
            yesorno: [
                { name: 'All', item: 'A'},
                { name: 'No', item: 'N'},
                { name: 'Yes', item: 'Y'}
            ],
            yesornoOnly: [
                { name: 'No', item: 'N'},
                { name: 'Yes', item: 'Y'}
            ],
        }
    },
    computed: {
        // Load subscription products from Vuex store
        allSubscriptionLevels() {
            const products = this.$store.getters.getSubscriptionProducts;
            if (!products) {
                // Return empty array if products unavailable - components should handle gracefully
                return [];
            }
            return products.allSubscriptionLevels || [];
        },
        validSubscriptionLevels() {
            const products = this.$store.getters.getSubscriptionProducts;
            if (!products) return [];
            return products.validSubscriptionLevels || [];
        },
        subscriptionLevels() {
            const products = this.$store.getters.getSubscriptionProducts;
            if (!products) return [];
            return products.subscriptionLevels || [];
        },
        validSubscriptionLevelsGrouped() {
            const products = this.$store.getters.getSubscriptionProducts;
            if (!products) return [];
            return products.validSubscriptionLevelsGrouped || [];
        },
        appTitle: function() {
            return process.env.VUE_APP_ENV_TITLE || 'Principal Task'
        },
        displayCookieWarning: function() {
        
            let display = true

            if(this.$auth && !this.$auth.loading && this.$auth.isAuthenticated) {
                // Don't display if the user is logged in.
                display = false;
            } else if (document.cookie.split(';').some(function(item) {
                return item.trim().indexOf('CookiesAcknowledged=') == 0
            })) {
            
                // User has accepted cookies within the last thirty (30) days
                display = false
            }
            
            return display

        },
    },
    methods: {
        getNameForSubscription(subscriptionCode) {
            
            let response = subscriptionCode + ' is unknown'
            
            this.subscriptionLevels.forEach((tier, tierIndex) => {

                if(tier.options) {
                    
                    tier.options.forEach((level, levelIndex) => {
                        
                        if(subscriptionCode === level.value) {
                            response = level.text
                        }
                    })
                }
            })
            
            return response

        },
        getSubscriptionTier(subscriptionCode) {
            
            let response = subscriptionCode + ' has an unknown subscription tier'

            this.subscriptionLevels.forEach((tier, tierIndex) => {

                if(tier.options) {
                    
                    tier.options.forEach((level, levelIndex) => {
                        
                        if(subscriptionCode === level.value) {
                            response = tier.value
                        }
                    })
                }
            })

            return response

        },
        isPremiumUser() {
            // 20260419 -- Copilot (Claude Sonnet 4.6) -- Force premium for all users when VUE_APP_FORCE_PREMIUM=true (testing only)
            if (process.env.VUE_APP_FORCE_PREMIUM === 'true') return true

            // 20260127 -- Copilot (Claude Sonnet 4.5) -- Check subscriptionTier in all environments
            // WHY: Premium gates should respect actual user subscription status

            // Must be logged in to access premium features
            if (typeof this.$auth == 'undefined' || this.$auth === null || this.$auth.loading || !this.$auth.isAuthenticated) {
                return false
            }

            let user = this.$store.getters.getUser
            
            if (typeof user == 'undefined' || user === null) {
                return false
            }

            // Check subscriptionTier - 'paid' means premium access
            return user.subscriptionTier === 'paid'
        },
        makeToast(append, title, message, variant) {

            ////console.log('Inside makeToast: "' + title + '"/"' + message + '"/"' + variant + '"')

            this.$bvToast.toast(message, {
                title: title,
                autoHideDelay: 2500,
                variant: variant
            })
        },
        setCookie() {

            document.cookie = "CookiesAcknowledged=YES;max-age=" + (60*60*24*30) + ";path=/";

        }
    }
}